import React from 'react'
import apiRest from '../../../services/apiRest'

// material-ui
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'

// types
interface Props {
  printState: any
  printType: any
  matches: boolean
  churchId: string
  showDetailsInPrint: boolean
  setOpenModalPrint: any
  isOpenModalPrint: any
  onChangePrintState: any
  setShowDetailsInPrint: (value: React.SetStateAction<boolean>) => void
}

export const Resume = ({
  printState,
  matches,
  churchId,
  showDetailsInPrint,
  setOpenModalPrint,
  printType,
  isOpenModalPrint,
  onChangePrintState,
  setShowDetailsInPrint,
}: Props) => {
  const onClickPrint = async () => {
    const url =
      printType === 'Extrato' ? '/transactions/pdf' : '/transactions/pdf-resume'
    const popup = window.open('', '_blank')
    if (popup) {
      if (!matches) {
        popup.document.write('arquivo baixado verifique o download')
      } else {
        popup.document.write('Aguarde...')
      }
      const { data } = await apiRest.get(url, {
        responseType: 'arraybuffer',
        params: {
          churchId,
          dateFrom: printState.dateFrom,
          dateTo: printState.dateTo,
          details:
            printType === 'Relatório' && showDetailsInPrint ? '' : undefined,
        },
      })

      const pdfURL = URL.createObjectURL(
        new Blob([data], { type: 'application/pdf' })
      )
      popup.location.href = pdfURL

      if (!matches) {
        // corrigir erro no android
        var fileLink = document.createElement('a')
        fileLink.href = pdfURL
        fileLink.download = 'resumo-pdf'
        fileLink.click()
        popup.document.write('arquivo baixado verifique o download')
      } else {
        setTimeout(() => {
          URL.revokeObjectURL(pdfURL)
          popup.print()
        }, 500)
      }
    }
  }
  return (
    <>
      <Dialog onClose={() => setOpenModalPrint(false)} open={isOpenModalPrint}>
        <DialogTitle>{printType}</DialogTitle>
        <DialogContent>
          <TextField
            type="date"
            label="Data inicial"
            value={printState.dateFrom}
            onChange={onChangePrintState('dateFrom')}
          />
          <TextField
            type="date"
            label="Data final"
            value={printState.dateTo}
            onChange={onChangePrintState('dateTo')}
          />
          {printType === 'Relatório' && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showDetailsInPrint}
                    onChange={() => setShowDetailsInPrint((value) => !value)}
                  />
                }
                label="Exibir detalhes"
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalPrint(false)}>Cancelar</Button>
          <Button onClick={onClickPrint} color="primary">
            Imprimir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
